import { NotifyType } from "UidispatcherApiModule";
//@ts-ignore
const UidispatcherApiModule = await import("uidispatcher_api/UidispatcherApiModule");
export const notify: NotifyType = UidispatcherApiModule.notify;
